import React from 'react';

import { useIntl } from 'react-intl';

import MainLayout from 'src/components/layout/MainLayout';
import ValidationTypesTable from 'src/features/validationTypes/components/tables/ValidationTypesTable';
import { validationTypesMessages } from 'src/features/validationTypes/utils/messages';
import { useTitleStore } from 'src/stores/useTitleStore';

const ValidationTypesLayout = () => {
    const { formatMessage } = useIntl();

    const { setTitle, removeTitle } = useTitleStore();

    React.useEffect(() => {
        setTitle(formatMessage(validationTypesMessages.validationTypes));
        return removeTitle;
    }, [formatMessage, removeTitle, setTitle]);

    return (
        <MainLayout>
            <ValidationTypesTable />
        </MainLayout>
    );
};

export default ValidationTypesLayout;
